import { expand } from 'uri-template-lite';
import { z } from 'zod/v3';
import { SampleUrl } from './SampleUrl';
import { apiClient } from '../../common/ApiClient';
import { createApiQueryHook } from '../../common/queryClient/createApiQueryHook';

interface SampleScopeUsersRequestParams {
  id: number;
  type: string;
  valueDate: string;
}

const SampleScopeUsersSchema = z.object({
  dataManagers: z.array(z.string()),
  dataModifiedBy: z.array(z.string()),
});

export type SampleScopeUsersType = z.infer<typeof SampleScopeUsersSchema>;

const getSampleScopeUsers = async (
  params: SampleScopeUsersRequestParams,
): Promise<SampleScopeUsersType> =>
  apiClient
    .get(expand(SampleUrl.scopeUsers, params))
    .then((response) => SampleScopeUsersSchema.parse(response.data));

export const useSampleScopeUsersQuery = createApiQueryHook(
  ['sample-scope-users'],
  getSampleScopeUsers,
);
